import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import config from '../../../../config';

const DEFAULT_LOCALE = config('defaultLocale');

const withInventoryItemRecommendations = Component =>
  graphql(
    gql`
  query withInventoryItemRecommendations(
    $workId: ID!,
    $currency: String = "AUD",
    $country: String = "AU",
    $locale: String = "${DEFAULT_LOCALE}"
  ) {
    inventoryItemRecommendations(workId: $workId, limit: 3) {
      ...${Component.displayName}
    }
  }
  ${Component.fragment}
`,
    {
      props: ({
        data: { inventoryItemRecommendations, loading, error },
        componentProps
      }) => {
        return {
          ...componentProps,
          loading,
          error,
          products: inventoryItemRecommendations || []
        };
      },
      options: props => {
        const { workId, userInfo } = props;
        const { country, currency, locale } = userInfo;

        return {
          variables: {
            workId,
            country,
            currency,
            locale
          }
        };
      }
    }
  )(Component);

withInventoryItemRecommendations.displayName =
  'withInventoryItemRecommendations';

export default withInventoryItemRecommendations;
